import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import DevKeyForm from './DevKeyForm'
import DevKeyDetails from './DevKeyDetails'
import { useStateValue } from '../../../state'

const DevKeyContainer = ({organization, setOrganization, toggle}) => {

  const [currentState] = useStateValue()
  let content = !currentState.isAdmin ? (
    <DevKeyDetails devKey={organization.devKey} />
  ) : (
    <DevKeyForm
      organization={organization}
      setOrganization={setOrganization}
      toggle={toggle}
    />
  )
  return <Fragment>{content}</Fragment>
}

DevKeyContainer.propTypes = {
  organization: PropTypes.object.isRequired,
  setOrganization: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default DevKeyContainer
